'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = require('./icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _icon2.default; /**
                                   * Created by jf on 15/11/3.
                                   */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/icon/index.js
// module id = 89
// module chunks = 7